<template>
  <v-list-item>
    <BaseMenu
      :icon="icon"
      :left="left"
      :bottom="bottom"
      :offsetY="offsetY"
      :offsetX="offsetX"
      :capitalize="capitalize"
      :loading="loading"
      :tooltip="title"
      :title="title"
      :label="title"
      :renderTable="renderTable"
      :tableHeaders="tableHeaders"
      :isCertificationHistory="isCertificationHistory"
      :dropdownLinks="items"
      :disableStyleIcon="disableStyleIconListItemMenu"
      :dataCy="dataCy"
      @click="onClickEmit"
      @selected-option="$emit('selected-option', $event)"
    />
  </v-list-item>
</template>

<script>
import BaseMenu from '@/components/shared/navigation/BaseMenu';

export default {
    components: {
        BaseMenu,
    },
    props: {
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            default: () => [],
        },
        capitalize: {
            type: Boolean,
            default: false,
        },
        left: {
            type: Boolean,
            default: true,
        },
        bottom: {
            type: Boolean,
            default: true,
        },
        offsetX: {
            type: Boolean,
            default: true,
        },
        offsetY: {
            type: Boolean,
            default: true,
        },
        isCertificationHistory: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: '',
        },
        renderTable: {
            type: Boolean,
            default: false,
        },
        tableHeaders: {
            type: Array,
            default: () => [],
        },
        disableStyleIconListItemMenu: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    watch: {
        items() {
            this.loading = !this.loading;
        },
    },
    methods: {
        onClickEmit() {
            this.loading = true;
            this.$emit('click');
        },
    },
};
</script>
